<div class="dialog-container">
    <h1 class="condensed dialog-title">{{dialogTitle()}}</h1>
    <div class="dialog-content">
        <div class="row">
            <mat-form-field class="col-6" appearance="fill">
                <mat-label>Percentage</mat-label>
                <input
                    [(ngModel)]="percentage"
                    [decimalInput]="3"
                    [maxNumberLength]="3"
                    appDecimalInput
                    matInput>
                <span matSuffix>%</span>
                <mat-hint>Gebaseerd op huidige delen</mat-hint>
            </mat-form-field>
            <mat-form-field class="col-6 txtblack" appearance="fill">
                <mat-label>Totaal bedrag</mat-label>
                <span matPrefix>€&nbsp;&nbsp;</span>
                <input disabled matInput type="text" value="{{tailChargeDialogData.totalPrice * (percentage / 100) | number:'1.2-2'}}">
            </mat-form-field>
        </div>

        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Opmerking</mat-label>
            <input [(ngModel)]="comment" matInput placeholder="Opmerking" type="text">
        </mat-form-field>

    </div>
    <div class="d-flex flex-wrap">
        <button mat-button (click)="close()">Annuleren</button>
        <div class="spacer"></div>
        @if (hasId()) {
            <button (click)="delete()" class="me-3" color="primary" mat-icon-button>
                <i class="fas fa-trash"></i>
            </button>
        }
        <button (click)="save()" cdkFocusInitial color="primary" mat-raised-button>
            {{buttonLabel()}}
        </button>
    </div>
</div>
